/* import __COLOCATED_TEMPLATE__ from './entity-type.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { LegalEntitiesBusinessEntityType, NonIndividualLegalEntitiesBusinessEntityType } from '@banking/api/utils/business-types';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
const DUMMY_TINS = new Set(['000000000', '111111111', '222222222', '333333333', '444444444', '555555555', '666666666', '777777777', '888888888', '999999999', '012345678', '123456789', '987654321', '000000001', '111223333', '123121234', '123123123', '123451234']);
let EntityType = (_class = class EntityType extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "entityType", _descriptor2, this);
    _initializerDefineProperty(this, "taxId", _descriptor3, this);
    _initializerDefineProperty(this, "confirmationTaxId", _descriptor4, this);
    _initializerDefineProperty(this, "showValidation", _descriptor5, this);
    this.setDefaultEntityType();
  }
  setDefaultEntityType() {
    const isTypeInList = this.args.entityType && this.businessTypeOptions.some(option => option.value === this.args.entityType);
    if (isTypeInList) {
      this.entityType = this.args.entityType;
    }
  }
  get validationTaxIdFields() {
    if (!this.doesEinHave9Digits) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationEinRequired')
      };
    } else if (!this.isEinValid) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationInvalidEin')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  get validationConfirmationTaxIdFields() {
    if (!this.isEinMatching) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationConfirmationEinRequired')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  get validationEntityTypeField() {
    if (!this.entityType) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.entityType.validationEntityTypeRequired')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  isValid() {
    return !this.validationTaxIdFields.isInvalid && !this.validationConfirmationTaxIdFields.isInvalid && !this.validationEntityTypeField.isInvalid;
  }
  get doesEinHave9Digits() {
    // TODO: only some prefixes are valid, should we check? https://www.irs.gov/businesses/small-businesses-self-employed/how-eins-are-assigned-and-valid-ein-prefixes
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId?.trim().replace(/[•-]/g, '').match(/^\d{9}$/);
  }
  get isEinMatching() {
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId === this.confirmationTaxId;
  }
  get businessTypeOptions() {
    const entityTypesToExclude = this.args.entityTypesToExclude ?? [];
    return Object.keys(NonIndividualLegalEntitiesBusinessEntityType).map(typeLabel => {
      return {
        value: LegalEntitiesBusinessEntityType[
        // We know typeLabel is actually this type since it comes from
        // Object.keys of the enum above
        typeLabel],
        // eslint-disable-next-line square/no-translation-key-interpolation
        label: this.intl.t(`banking.enums.entityType.${typeLabel}`)
      };
    }).filter(businessEntityType => !entityTypesToExclude.includes(businessEntityType.value));
  }
  get isEinValid() {
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId && !DUMMY_TINS.has(this.taxId);
  }
  updateEntityType(event) {
    const entityType = Number(event.detail.value);
    this.entityType = entityType;
    this.args.onEntityTypeChange(this.entityType);
  }
  submit(event) {
    event.preventDefault();
    if (!this.isValid() || !this.entityType) {
      this.showValidation = true;
      return;
    }
    const data = {
      entityType: this.entityType,
      taxId: this.taxId
    };
    this.args.onSubmit(data);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "entityType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "taxId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "confirmationTaxId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateEntityType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEntityType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class);
export { EntityType as default };